import React from 'react';

import clsx from 'clsx';

export const ExternalLinkComponent = ({ to, target, children, className = null, rel = 'nofollow' }) => (
  <a href={to} target={target} className={clsx(className ? className : '')} rel={rel}>
    {children}
  </a>
);
